function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../hoc/compose');

var textLabelBase = require('./textLabelBase');

var displayNames = require('./displayNames');

var Bubble = /*#__PURE__*/function (_React$Component) {
  _inherits(Bubble, _React$Component);

  var _super = _createSuper(Bubble);

  function Bubble(props) {
    var _this;

    _classCallCheck(this, Bubble);

    _this = _super.call(this, props);

    _this.getContentRef = function (ref) {
      _this.content = ref;
    };

    _this.getContentStyle = function () {
      return _this.props.maxWidth ? _.assign({
        maxWidth: _this.props.maxWidth
      }, _this.props.contentStyle) : _this.props.contentStyle;
    };

    _this.getChildren = function () {
      if (_.isString(_this.props.children)) {
        return React.createElement(textLabelBase, {
          shouldTranslate: props.shouldTranslate,
          value: _this.props.children
        });
      }

      return _this.props.children;
    };

    return _this;
  }

  _createClass(Bubble, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_.isFunction(this.props.onLayoutChange)) {
        this.props.onLayoutChange(this.content);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didTargetContentChanged = !_.isEqual(this.props.targetContent, prevProps.targetContent);
      var shouldReLayout = didTargetContentChanged || !_.isEqual(this.props.contentStyle, prevProps.contentStyle);

      if (_.isFunction(this.props.onLayoutChange) && shouldReLayout) {
        this.props.onLayoutChange(this.content);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        className: this.props.getClassName("bubble".concat(this.props.isHint ? ' hint' : '', " arrow-").concat(this.props.arrowAlignment)),
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        onClick: this.props.onClick,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement("div", {
        className: "bubble-content",
        ref: this.getContentRef,
        style: this.getContentStyle(),
        key: "content"
      }, this.getChildren()), this.props.arrowStyle ? /*#__PURE__*/React.createElement("div", {
        className: "bubble-arrow",
        key: "arrow",
        style: this.props.arrowStyle
      }) : null);
    }
  }]);

  return Bubble;
}(React.Component);

Bubble.displayName = displayNames.BUBBLE;
Bubble.propTypes = {
  onLayoutChange: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  arrowAlignment: PropTypes.string,
  arrowStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  targetContent: PropTypes.object,
  maxWidth: PropTypes.number,
  isHint: PropTypes.bool,
  dataHook: PropTypes.string
};
Bubble.defaultProps = {
  maxWidth: 240
};
module.exports = compose(Bubble);